import axios from "axios"
import { DEFAULT_ADDRESS, supportNetworkList } from "../../constants"
import { ethers } from "ethers";
import { executeLzReceive } from "../../api";

const LayerzeroTestBaseUrl = "https://scan-testnet.layerzero-api.com/v1"
const LayerzeroMainBaseUrl = "https://scan.layerzero-api.com/v1"

const abi = [
  "event LzReceiveAlert(address indexed receiver, address indexed executor, tuple(uint32 srcEid, bytes32 sender, uint64 nonce) origin, bytes32 guid, uint256 gas, uint256 value, bytes message, bytes extraData, bytes reason)"
];

const namespaced = true

const state = {
  msg: [],
  msgLoading: false
}

const getters = {}

const mutations = {
  setMsg(state, msg) {
    state.msg = msg
  },
  setMsgLoading(state) {
    state.msgLoading = !state.msgLoading
  }
}

const actions = {
  async getLayerzeroMessage({ rootState, commit }) {
    const { currentNetwork, account } = rootState.wallet
    
    if (account === DEFAULT_ADDRESS) return
    if (currentNetwork) {
      const layerzeroUrl = !!currentNetwork.isTestnet ? LayerzeroTestBaseUrl : LayerzeroMainBaseUrl

      try {
        commit('setMsgLoading')

        const res = await axios.get(`${layerzeroUrl}/messages/wallet/${account}?limit=10`)
        // const res = {
        //   data: {
        //     "data": [
        //       {
        //         "pathway": {
        //           "srcEid": 40161,
        //           "dstEid": 40156,
        //           "sender": {
        //             "address": "0xeea94706c3f4760c6eed7590a53d8f394685817a",
        //             "chain": "sepolia"
        //           },
        //           "receiver": {
        //             "address": "0xb41a27cea6535c8d972607f9bc81590c409ab8f2",
        //             "chain": "meter-testnet"
        //           },
        //           "id": "40161-40156-0xeea94706c3f4760c6eed7590a53d8f394685817a-0xb41a27cea6535c8d972607f9bc81590c409ab8f2",
        //           "nonce": 1
        //         },
        //         "source": {
        //           "status": "SUCCEEDED",
        //           "tx": {
        //             "txHash": "0x7f375cfa0c17f8713ec86549318cd9a96b65132a1127e792375f9030d115666a",
        //             "blockHash": "0x9e4b942e52adbc1dadf29c9521b9f2362aca6f17b277fa6cf7d55e6603c6a1ab",
        //             "blockNumber": "7348594",
        //             "blockTimestamp": 1735087284,
        //             "from": "0x57e7e16a2326dc41d02402103a73b4464a8b3eeb",
        //             "payload": "0x00000000000000000000000057e7e16a2326dc41d02402103a73b4464a8b3eeb00000000000f4240000000000000000000000000722ccb55ab1752796cf34c12d1ea7083158ecaf900",
        //             "readinessTimestamp": 1735087308,
        //             "options": {
        //               "lzReceive": {
        //                 "gas": "1000000",
        //                 "value": "0"
        //               },
        //               "ordered": false
        //             }
        //           }
        //         },
        //         "destination": {
        //           "nativeDrop": {
        //             "status": "N/A"
        //           },
        //           "lzCompose": {
        //             "status": "N/A"
        //           },
        //           "status": "WAITING"
        //         },
        //         "verification": {
        //           "dvn": {
        //             "dvns": {
        //               "0xe3a4539200e8906c957cd85b3e7a515c9883fd81": {
        //                 "txHash": "0x3f5365fa3baac3d141945d9d7c317ac2e8bd036e3c4d564e5b852ee3447b985a",
        //                 "blockHash": "0x043257f9c7ede65844521e7519423a66537fe0d535f2c5e0d8de32d39edb94cb",
        //                 "blockNumber": 70408185,
        //                 "blockTimestamp": 1735087349,
        //                 "proof": {
        //                   "packetHeader": "0x01000000000000000100009ce1000000000000000000000000eea94706c3f4760c6eed7590a53d8f394685817a00009cdc000000000000000000000000b41a27cea6535c8d972607f9bc81590c409ab8f2",
        //                   "payloadHash": "0x16a68c3c29c4027ddd9423ca53a5eaa3136f28a156cdd4e477c188cddb9c02d6"
        //                 },
        //                 "optional": false,
        //                 "status": "SUCCEEDED"
        //               }
        //             },
        //             "status": "SUCCEEDED"
        //           },
        //           "sealer": {
        //             "status": "WAITING"
        //           }
        //         },
        //         "guid": "0xa35aca78f85f28596aacb4f5ff66408a7d2586e3abb1581bbc94e6d62e630843",
        //         "config": {
        //           "error": false,
        //           "dvnConfigError": false,
        //           "receiveLibrary": "0xeA2B12219472e0d2a7795c7f61B0602bF5c36E25",
        //           "sendLibrary": "0xcc1ae8Cf5D3904Cef3360A9532B477529b177cCE",
        //           "inboundConfig": {
        //             "confirmations": 2,
        //             "requiredDVNCount": 1,
        //             "optionalDVNCount": 0,
        //             "optionalDVNThreshold": 0,
        //             "requiredDVNs": [
        //               "0xe3a4539200e8906c957cd85b3e7a515c9883fd81"
        //             ],
        //             "requiredDVNNames": [
        //               "LayerZero Labs"
        //             ],
        //             "optionalDVNs": [
                      
        //             ],
        //             "optionalDVNNames": [
                      
        //             ]
        //           },
        //           "outboundConfig": {
        //             "confirmations": 2,
        //             "requiredDVNCount": 1,
        //             "optionalDVNCount": 0,
        //             "optionalDVNThreshold": 0,
        //             "requiredDVNs": [
        //               "0x8eebf8b423b73bfca51a1db4b7354aa0bfca9193"
        //             ],
        //             "requiredDVNNames": [
        //               "LayerZero Labs"
        //             ],
        //             "optionalDVNs": [
                      
        //             ],
        //             "optionalDVNNames": [
                      
        //             ]
        //           },
        //           "ulnSendVersion": "V302",
        //           "ulnReceiveVersion": "V302"
        //         },
        //         "status": {
        //           "name": "INFLIGHT",
        //           "message": "Ready for committer to commit verification"
        //         },
        //         "created": "2024-12-25T00:42:31.000Z",
        //         "updated": "2024-12-25T00:42:39.000Z"
        //       },
        //       {
        //         "pathway": {
        //           "srcEid": 40156,
        //           "dstEid": 40161,
        //           "sender": {
        //             "address": "0xb41a27cea6535c8d972607f9bc81590c409ab8f2",
        //             "chain": "meter-testnet"
        //           },
        //           "receiver": {
        //             "address": "0xeea94706c3f4760c6eed7590a53d8f394685817a",
        //             "chain": "sepolia"
        //           },
        //           "id": "40156-40161-0xb41a27cea6535c8d972607f9bc81590c409ab8f2-0xeea94706c3f4760c6eed7590a53d8f394685817a",
        //           "nonce": 12
        //         },
        //         "source": {
        //           "status": "SUCCEEDED",
        //           "tx": {
        //             "txHash": "0x0cfb9e5c6fe396b009f88195526d826953d91d048a671de4efda3fb331bb0557",
        //             "blockHash": "0x043181d6879d0a71225ef9f786d41f691c182e568087858084a27c35a6f21e7f",
        //             "blockNumber": "70353366",
        //             "blockTimestamp": 1735008742,
        //             "from": "0x57e7e16a2326dc41d02402103a73b4464a8b3eeb",
        //             "payload": "0x00000000000000000000000057e7e16a2326dc41d02402103a73b4464a8b3eeb000000000098968000000000000000000000000096159a91291c92df19983e53e14726b1de3f7c4901",
        //             "readinessTimestamp": 1735008744,
        //             "options": {
        //               "lzReceive": {
        //                 "gas": "1000000",
        //                 "value": "0"
        //               },
        //               "ordered": false
        //             }
        //           }
        //         },
        //         "destination": {
        //           "nativeDrop": {
        //             "status": "N/A"
        //           },
        //           "lzCompose": {
        //             "status": "N/A"
        //           },
        //           "tx": {
        //             "txHash": "0xf9aadb791a80595f4eaa6c235f3370ca2ea4d8fae68e38fe937078fd6d007fae",
        //             "blockHash": "0x3393d2b689f95a18e4af4d197fc98e7974820a3a435d6707e0f142d2d41360bd",
        //             "blockNumber": 7345326,
        //             "blockTimestamp": 1735045860
        //           },
        //           "status": "SUCCEEDED"
        //         },
        //         "verification": {
        //           "dvn": {
        //             "dvns": {
        //               "0x8eebf8b423b73bfca51a1db4b7354aa0bfca9193": {
        //                 "txHash": "0x58f043d8d185bf2f685e99179f35218358a4648f65c38e977d36221672a3c007",
        //                 "blockHash": "0xd8463fde39ef2409632e6cb4653a1f2f763ff43660e1806348e1c186b414db6a",
        //                 "blockNumber": 7342404,
        //                 "blockTimestamp": 1735008780,
        //                 "proof": {
        //                   "packetHeader": "0x01000000000000000c00009cdc000000000000000000000000b41a27cea6535c8d972607f9bc81590c409ab8f200009ce1000000000000000000000000eea94706c3f4760c6eed7590a53d8f394685817a",
        //                   "payloadHash": "0xb761c3b6a24fed7c4da1d1665d79df36d6e8ba7fa8003c5564780138cea752b5"
        //                 },
        //                 "optional": false,
        //                 "status": "SUCCEEDED"
        //               }
        //             },
        //             "status": "SUCCEEDED"
        //           },
        //           "sealer": {
        //             "tx": {
        //               "txHash": "0x80109b761422e456ecd13bdc3fd920cdf9c4fe8dacb90b1df7994397ec18a3a7",
        //               "blockHash": "0x52e0766bb8ae68c1470f955c2ae597459eb135a1436f83bbd2b5e296b4f12ad5",
        //               "blockNumber": 7345286,
        //               "blockTimestamp": 1735045332
        //             },
        //             "status": "SUCCEEDED"
        //           }
        //         },
        //         "guid": "0x27f4fdb9ac3e31fc14ff77d950787a7c8a26724acc5cffd26666c4449c80b270",
        //         "config": {
        //           "error": false,
        //           "receiveLibrary": "0xdAf00F5eE2158dD58E0d3857851c432E34A3A851",
        //           "sendLibrary": "0x6B946AF0b8F3B4D33a36f90C5227D0054722FF32",
        //           "inboundConfig": {
        //             "confirmations": 1,
        //             "requiredDVNCount": 1,
        //             "optionalDVNCount": 0,
        //             "optionalDVNThreshold": 0,
        //             "requiredDVNs": [
        //               "0x8eebf8b423b73bfca51a1db4b7354aa0bfca9193"
        //             ],
        //             "requiredDVNNames": [
        //               "LayerZero Labs"
        //             ],
        //             "optionalDVNs": [
                      
        //             ],
        //             "optionalDVNNames": [
                      
        //             ]
        //           },
        //           "outboundConfig": {
        //             "confirmations": 1,
        //             "requiredDVNCount": 1,
        //             "optionalDVNCount": 0,
        //             "optionalDVNThreshold": 0,
        //             "requiredDVNs": [
        //               "0xe3a4539200e8906c957cd85b3e7a515c9883fd81"
        //             ],
        //             "requiredDVNNames": [
        //               "LayerZero Labs"
        //             ],
        //             "optionalDVNs": [
                      
        //             ],
        //             "optionalDVNNames": [
                      
        //             ],
        //             "executor": "0x68921A9530579203EE812ebddd0eE31ED43E7040"
        //           },
        //           "ulnSendVersion": "V302",
        //           "ulnReceiveVersion": "V302"
        //         },
        //         "status": {
        //           "name": "DELIVERED",
        //           "message": "Executor transaction confirmed"
        //         },
        //         "created": "2024-12-24T02:52:30.000Z",
        //         "updated": "2024-12-24T13:13:52.000Z"
        //       },
        //       {
        //         "pathway": {
        //           "srcEid": 40156,
        //           "dstEid": 40161,
        //           "sender": {
        //             "address": "0xb41a27cea6535c8d972607f9bc81590c409ab8f2",
        //             "chain": "meter-testnet"
        //           },
        //           "receiver": {
        //             "address": "0xeea94706c3f4760c6eed7590a53d8f394685817a",
        //             "chain": "sepolia"
        //           },
        //           "id": "40156-40161-0xb41a27cea6535c8d972607f9bc81590c409ab8f2-0xeea94706c3f4760c6eed7590a53d8f394685817a",
        //           "nonce": 11
        //         },
        //         "source": {
        //           "status": "SUCCEEDED",
        //           "tx": {
        //             "txHash": "0xc1a0c77597b6f8870ca95f8a3f9b9f3ed611d01291c55f394a3c7bccf7e0b05a",
        //             "blockHash": "0x0431812caf34c4b7feb77c9b37401dc8a34b01d5d7e49fd79a3f45cb414d272c",
        //             "blockNumber": "70353196",
        //             "blockTimestamp": 1735008499,
        //             "from": "0x57e7e16a2326dc41d02402103a73b4464a8b3eeb",
        //             "payload": "0x00000000000000000000000057e7e16a2326dc41d02402103a73b4464a8b3eeb000000000098968000000000000000000000000096159a91291c92df19983e53e14726b1de3f7c4901",
        //             "readinessTimestamp": 1735008500,
        //             "options": {
        //               "lzReceive": {
        //                 "gas": "1000000",
        //                 "value": "0"
        //               },
        //               "ordered": false
        //             }
        //           }
        //         },
        //         "destination": {
        //           "nativeDrop": {
        //             "status": "N/A"
        //           },
        //           "lzCompose": {
        //             "status": "N/A"
        //           },
        //           "tx": {
        //             "txHash": "0x7b75a84168849a4f30d1ffab127afe946a23977228dcc0ff0d95687ea4e135ba",
        //             "blockHash": "0x3393d2b689f95a18e4af4d197fc98e7974820a3a435d6707e0f142d2d41360bd",
        //             "blockNumber": 7345326,
        //             "blockTimestamp": 1735045860
        //           },
        //           "status": "SUCCEEDED"
        //         },
        //         "verification": {
        //           "dvn": {
        //             "dvns": {
        //               "0x8eebf8b423b73bfca51a1db4b7354aa0bfca9193": {
        //                 "txHash": "0x4815d90538075c75a2f5576ac93667b31854aa52c4bffeac44d604dd94c9377b",
        //                 "blockHash": "0x1a20f7d6583eacf3bfed848d0adcbed7d305b1b6e3dd99a6ccca526676166bec",
        //                 "blockNumber": 7342383,
        //                 "blockTimestamp": 1735008516,
        //                 "proof": {
        //                   "packetHeader": "0x01000000000000000b00009cdc000000000000000000000000b41a27cea6535c8d972607f9bc81590c409ab8f200009ce1000000000000000000000000eea94706c3f4760c6eed7590a53d8f394685817a",
        //                   "payloadHash": "0xcfe383223a12f27a4f40284416c6715b5a401df8ee90f2300344319510ef4416"
        //                 },
        //                 "optional": false,
        //                 "status": "SUCCEEDED"
        //               }
        //             },
        //             "status": "SUCCEEDED"
        //           },
        //           "sealer": {
        //             "tx": {
        //               "txHash": "0xcf16c6783ac5654c4084df34d90ae0a3559575d7c88319c9d55a6bf05cc3a8e1",
        //               "blockHash": "0x4fb3913d7d032240b289062531f3a64b8ce9cb3ec26eee779495bef99714523b",
        //               "blockNumber": 7345285,
        //               "blockTimestamp": 1735045320
        //             },
        //             "status": "SUCCEEDED"
        //           }
        //         },
        //         "guid": "0xb5e17a6158354de0bde7f2a8b58de1d477c51317e21c9d6b67a249f7fad1571e",
        //         "config": {
        //           "error": false,
        //           "receiveLibrary": "0xdAf00F5eE2158dD58E0d3857851c432E34A3A851",
        //           "sendLibrary": "0x6B946AF0b8F3B4D33a36f90C5227D0054722FF32",
        //           "inboundConfig": {
        //             "confirmations": 1,
        //             "requiredDVNCount": 1,
        //             "optionalDVNCount": 0,
        //             "optionalDVNThreshold": 0,
        //             "requiredDVNs": [
        //               "0x8eebf8b423b73bfca51a1db4b7354aa0bfca9193"
        //             ],
        //             "requiredDVNNames": [
        //               "LayerZero Labs"
        //             ],
        //             "optionalDVNs": [
                      
        //             ],
        //             "optionalDVNNames": [
                      
        //             ]
        //           },
        //           "outboundConfig": {
        //             "confirmations": 1,
        //             "requiredDVNCount": 1,
        //             "optionalDVNCount": 0,
        //             "optionalDVNThreshold": 0,
        //             "requiredDVNs": [
        //               "0xe3a4539200e8906c957cd85b3e7a515c9883fd81"
        //             ],
        //             "requiredDVNNames": [
        //               "LayerZero Labs"
        //             ],
        //             "optionalDVNs": [
                      
        //             ],
        //             "optionalDVNNames": [
                      
        //             ],
        //             "executor": "0x68921A9530579203EE812ebddd0eE31ED43E7040"
        //           },
        //           "ulnSendVersion": "V302",
        //           "ulnReceiveVersion": "V302"
        //         },
        //         "status": {
        //           "name": "DELIVERED",
        //           "message": "Executor transaction confirmed"
        //         },
        //         "created": "2024-12-24T02:48:35.000Z",
        //         "updated": "2024-12-24T13:14:19.000Z"
        //       },
        //       {
        //         "pathway": {
        //           "srcEid": 40156,
        //           "dstEid": 40161,
        //           "sender": {
        //             "address": "0xb41a27cea6535c8d972607f9bc81590c409ab8f2",
        //             "chain": "meter-testnet"
        //           },
        //           "receiver": {
        //             "address": "0xeea94706c3f4760c6eed7590a53d8f394685817a",
        //             "chain": "sepolia"
        //           },
        //           "id": "40156-40161-0xb41a27cea6535c8d972607f9bc81590c409ab8f2-0xeea94706c3f4760c6eed7590a53d8f394685817a",
        //           "nonce": 10
        //         },
        //         "source": {
        //           "status": "SUCCEEDED",
        //           "tx": {
        //             "txHash": "0x5b1af143d1bef6b8ff0f1c16ab3c001f73084d12069b5c92c87ff0b35e468097",
        //             "blockHash": "0x042e798c970f3bff5a4bf40121a638e26977e296e63e211c282e91743e209714",
        //             "blockNumber": "70154636",
        //             "blockTimestamp": 1734523215,
        //             "from": "0x57e7e16a2326dc41d02402103a73b4464a8b3eeb",
        //             "payload": "0x00000000000000000000000057e7e16a2326dc41d02402103a73b4464a8b3eeb000000000098968000000000000000000000000096159a91291c92df19983e53e14726b1de3f7c4901",
        //             "readinessTimestamp": 1734523217,
        //             "options": {
        //               "lzReceive": {
        //                 "gas": "1000000",
        //                 "value": "0"
        //               },
        //               "ordered": false
        //             }
        //           }
        //         },
        //         "destination": {
        //           "nativeDrop": {
        //             "status": "N/A"
        //           },
        //           "lzCompose": {
        //             "status": "N/A"
        //           },
        //           "tx": {
        //             "txHash": "0x8cb5596d8285459b877d1d4a43ed6d1a72248cd7324f2c90c85ed8d20e925b22",
        //             "blockHash": "0x6dbfad139566bc38ea67332eaa34341e46aac973151bed749cd9828bab282d13",
        //             "blockNumber": 7304291,
        //             "blockTimestamp": 1734523356
        //           },
        //           "status": "SUCCEEDED"
        //         },
        //         "verification": {
        //           "dvn": {
        //             "dvns": {
        //               "0x8eebf8b423b73bfca51a1db4b7354aa0bfca9193": {
        //                 "txHash": "0xb274a184962cbb7bd6c6c92d8b869c48829a1fc83397e5cf65bf61592ad5a62c",
        //                 "blockHash": "0xd46cf9a7aee69a646fc66ba7b521b9a66cc6d40cae20f4fa6fb76fdb9fe828b9",
        //                 "blockNumber": 7304281,
        //                 "blockTimestamp": 1734523236,
        //                 "proof": {
        //                   "packetHeader": "0x01000000000000000a00009cdc000000000000000000000000b41a27cea6535c8d972607f9bc81590c409ab8f200009ce1000000000000000000000000eea94706c3f4760c6eed7590a53d8f394685817a",
        //                   "payloadHash": "0xabbb180fd26ba1a395ec32aa131f7a131a0ebffda4c12b3ac204b5f931130ddc"
        //                 },
        //                 "optional": false,
        //                 "status": "SUCCEEDED"
        //               }
        //             },
        //             "status": "SUCCEEDED"
        //           },
        //           "sealer": {
        //             "tx": {
        //               "txHash": "0x1f21400608e4c6a06a574b0e7771b05367f6546d9fbde57a084ad61d9dbe8210",
        //               "blockHash": "0xc2e8ffb8e2fa0504185f1d5368ed543a6131bfffd77929f53c0593d2342ea02b",
        //               "blockNumber": 7304286,
        //               "blockTimestamp": 1734523296
        //             },
        //             "status": "SUCCEEDED"
        //           }
        //         },
        //         "guid": "0xe89bdde8dd5b96fcb3ce679ad8f90eac8a5f65bcc08e21f74ba82b098c9c6c4c",
        //         "config": {
        //           "error": false,
        //           "receiveLibrary": "0xdAf00F5eE2158dD58E0d3857851c432E34A3A851",
        //           "sendLibrary": "0x6B946AF0b8F3B4D33a36f90C5227D0054722FF32",
        //           "inboundConfig": {
        //             "confirmations": 1,
        //             "requiredDVNCount": 1,
        //             "optionalDVNCount": 0,
        //             "optionalDVNThreshold": 0,
        //             "requiredDVNs": [
        //               "0x8eebf8b423b73bfca51a1db4b7354aa0bfca9193"
        //             ],
        //             "requiredDVNNames": [
        //               "LayerZero Labs"
        //             ],
        //             "optionalDVNs": [
                      
        //             ],
        //             "optionalDVNNames": [
                      
        //             ]
        //           },
        //           "outboundConfig": {
        //             "confirmations": 1,
        //             "requiredDVNCount": 1,
        //             "optionalDVNCount": 0,
        //             "optionalDVNThreshold": 0,
        //             "requiredDVNs": [
        //               "0xe3a4539200e8906c957cd85b3e7a515c9883fd81"
        //             ],
        //             "requiredDVNNames": [
        //               "LayerZero Labs"
        //             ],
        //             "optionalDVNs": [
                      
        //             ],
        //             "optionalDVNNames": [
                      
        //             ],
        //             "executor": "0x68921A9530579203EE812ebddd0eE31ED43E7040"
        //           },
        //           "ulnSendVersion": "V302",
        //           "ulnReceiveVersion": "V302"
        //         },
        //         "status": {
        //           "name": "DELIVERED",
        //           "message": "Executor transaction confirmed"
        //         },
        //         "created": "2024-12-18T12:00:25.000Z",
        //         "updated": "2024-12-18T12:03:44.000Z"
        //       },
        //       {
        //         "pathway": {
        //           "srcEid": 40156,
        //           "dstEid": 40161,
        //           "sender": {
        //             "address": "0xb41a27cea6535c8d972607f9bc81590c409ab8f2",
        //             "chain": "meter-testnet"
        //           },
        //           "receiver": {
        //             "address": "0xeea94706c3f4760c6eed7590a53d8f394685817a",
        //             "chain": "sepolia"
        //           },
        //           "id": "40156-40161-0xb41a27cea6535c8d972607f9bc81590c409ab8f2-0xeea94706c3f4760c6eed7590a53d8f394685817a",
        //           "nonce": 9
        //         },
        //         "source": {
        //           "status": "SUCCEEDED",
        //           "tx": {
        //             "txHash": "0xc64dd64c6c0e68149f57581c5b84c7373cfa69076c63a866f7ded075e569dde0",
        //             "blockHash": "0x042e787528b39ceba1c30460fc373c86a980a246f979032066b8065a227a2e71",
        //             "blockNumber": "70154357",
        //             "blockTimestamp": 1734522808,
        //             "from": "0x57e7e16a2326dc41d02402103a73b4464a8b3eeb",
        //             "payload": "0x00000000000000000000000057e7e16a2326dc41d02402103a73b4464a8b3eeb00000000000f424000000000000000000000000096159a91291c92df19983e53e14726b1de3f7c4900",
        //             "readinessTimestamp": 1734522810,
        //             "options": {
        //               "lzReceive": {
        //                 "gas": "1000000",
        //                 "value": "0"
        //               },
        //               "ordered": false
        //             }
        //           }
        //         },
        //         "destination": {
        //           "nativeDrop": {
        //             "status": "N/A"
        //           },
        //           "lzCompose": {
        //             "status": "N/A"
        //           },
        //           "tx": {
        //             "txHash": "0xa810bd84e79fa41d0fed2ff898eadb342710157b78026054f99564e61ec1a3e6",
        //             "blockHash": "0x7bf05dc5034f4c3c11c56fae89495b6dc9341c0f05d38f4b123ff77004658a58",
        //             "blockNumber": 7304263,
        //             "blockTimestamp": 1734522984
        //           },
        //           "status": "SUCCEEDED"
        //         },
        //         "verification": {
        //           "dvn": {
        //             "dvns": {
        //               "0x8eebf8b423b73bfca51a1db4b7354aa0bfca9193": {
        //                 "txHash": "0xd8616d21087d2c5092f1c495977c0e5e606518ed2aab519170c86d284e766d2c",
        //                 "blockHash": "0x1bb7ba66d5025ee6a14890b16a0c70ddce028312598e93262cf60077d16fac71",
        //                 "blockNumber": 7304253,
        //                 "blockTimestamp": 1734522852,
        //                 "proof": {
        //                   "packetHeader": "0x01000000000000000900009cdc000000000000000000000000b41a27cea6535c8d972607f9bc81590c409ab8f200009ce1000000000000000000000000eea94706c3f4760c6eed7590a53d8f394685817a",
        //                   "payloadHash": "0xd59ac211bbc2c5a9536a99f8d2a8fe444f0946836912640f308dd088c3548be5"
        //                 },
        //                 "optional": false,
        //                 "status": "SUCCEEDED"
        //               }
        //             },
        //             "status": "SUCCEEDED"
        //           },
        //           "sealer": {
        //             "tx": {
        //               "txHash": "0x8f47dedece428071582ba650e9cf8a31139125474818687ad3e3baef01036afa",
        //               "blockHash": "0x879c7ce070d776e935ddfcd57d431a9e504881bd66822c387668714d018c8b91",
        //               "blockNumber": 7304259,
        //               "blockTimestamp": 1734522924
        //             },
        //             "status": "SUCCEEDED"
        //           }
        //         },
        //         "guid": "0xddc8b33f4fc157574848ac5cb831ba6ef05d0263108f8997783fb927799653f5",
        //         "config": {
        //           "error": false,
        //           "receiveLibrary": "0xdAf00F5eE2158dD58E0d3857851c432E34A3A851",
        //           "sendLibrary": "0x6B946AF0b8F3B4D33a36f90C5227D0054722FF32",
        //           "inboundConfig": {
        //             "confirmations": 1,
        //             "requiredDVNCount": 1,
        //             "optionalDVNCount": 0,
        //             "optionalDVNThreshold": 0,
        //             "requiredDVNs": [
        //               "0x8eebf8b423b73bfca51a1db4b7354aa0bfca9193"
        //             ],
        //             "requiredDVNNames": [
        //               "LayerZero Labs"
        //             ],
        //             "optionalDVNs": [
                      
        //             ],
        //             "optionalDVNNames": [
                      
        //             ]
        //           },
        //           "outboundConfig": {
        //             "confirmations": 1,
        //             "requiredDVNCount": 1,
        //             "optionalDVNCount": 0,
        //             "optionalDVNThreshold": 0,
        //             "requiredDVNs": [
        //               "0xe3a4539200e8906c957cd85b3e7a515c9883fd81"
        //             ],
        //             "requiredDVNNames": [
        //               "LayerZero Labs"
        //             ],
        //             "optionalDVNs": [
                      
        //             ],
        //             "optionalDVNNames": [
                      
        //             ],
        //             "executor": "0x68921A9530579203EE812ebddd0eE31ED43E7040"
        //           },
        //           "ulnSendVersion": "V302",
        //           "ulnReceiveVersion": "V302"
        //         },
        //         "status": {
        //           "name": "DELIVERED",
        //           "message": "Executor transaction confirmed"
        //         },
        //         "created": "2024-12-18T11:53:40.000Z",
        //         "updated": "2024-12-18T11:57:39.000Z"
        //       },
        //       {
        //         "pathway": {
        //           "srcEid": 10156,
        //           "dstEid": 10291,
        //           "sender": {
        //             "address": "0xac80eaa19bf652f13c03940da6fc6c6b45a029f5",
        //             "chain": "meter-testnet"
        //           },
        //           "receiver": {
        //             "address": "0xa61792f672d2b830881b7a58dea89c44ea7f3e5e",
        //             "chain": "bartio"
        //           },
        //           "id": "10156-10291-0xac80eaa19bf652f13c03940da6fc6c6b45a029f5-0xa61792f672d2b830881b7a58dea89c44ea7f3e5e",
        //           "nonce": 2
        //         },
        //         "source": {
        //           "status": "SUCCEEDED",
        //           "tx": {
        //             "txHash": "0x2081e6ac0490aec94a880fac3276e1c1fbd198124591ba4bb1f09a509c6ab8cb",
        //             "blockHash": "0x0409b38a64c86e8e65f3e9961e82c1fb2ba9b509a398af0ba14e01101317744a",
        //             "blockNumber": "67744650",
        //             "blockTimestamp": 1730942175,
        //             "from": "0x57e7e16a2326dc41d02402103a73b4464a8b3eeb",
        //             "blockConfirmations": 1,
        //             "payload": "0x000000000000000000000000000000000000000000000000000000000000000000000000000000000000000096159a91291c92df19983e53e14726b1de3f7c4900000000000000000000000000000000000000000000000000000000000000800000000000000000000000000000000000000000000000000de0b6b3a7640000000000000000000000000000000000000000000000000000000000000000001457e7e16a2326dc41d02402103a73b4464a8b3eeb000000000000000000000000",
        //             "value": "289017341040462427",
        //             "readinessTimestamp": 1730942176,
        //             "adapterParams": {
        //               "version": "1",
        //               "dstGasLimit": "200000"
        //             }
        //           }
        //         },
        //         "destination": {
        //           "status": "SUCCEEDED",
        //           "tx": {
        //             "txHash": "0x1cc011beafe7a5152cfa8b6016ef1b66ff3eea7eb0f38889cec37a6a9ed94abc",
        //             "blockHash": "0x8a5b2173f4d28d7eb1a15c860b97935c48776758a40dd573e449e286ada5deff",
        //             "blockNumber": 6542902,
        //             "blockTimestamp": 1730942203
        //           }
        //         },
        //         "guid": "0x9ff378f6d0a1b05e2429330f50ed0f33d71702f54bf66571b0cd50e3230bf4a7",
        //         "config": {
        //           "error": false,
        //           "receiveLibrary": "0x55370E0fBB5f5b8dAeD978BA1c075a499eB107B8",
        //           "inboundConfig": {
        //             "blockConfirmation": 1,
        //             "relayerAddress": "0x35AdD9321507A87471a11EBd4aE4f592d531e620",
        //             "oracleAddress": "0xF49d162484290EAeAd7bb8C2c7E3a6f8f52e32d6",
        //             "proofType": "2",
        //             "utilsVersion": 1,
        //             "proofVersion": "2",
        //             "proofLibraryAddress": "0x4e08B1F1AC79898569CfB999FB92B5495FB18A2B",
        //             "ulnVersion": "V2"
        //           },
        //           "outboundConfig": {
        //             "blockConfirmation": 1,
        //             "relayerAddress": "0xf35848b061f7b0A4F69BCA8804947e1EE29Ff734",
        //             "oracleAddress": "0xE3A4539200E8906C957cD85b3E7a515c9883Fd81",
        //             "proofType": "2"
        //           },
        //           "ulnSendVersion": "V2"
        //         },
        //         "status": {
        //           "name": "DELIVERED",
        //           "message": "Destination transaction confirmed"
        //         },
        //         "created": "2024-11-07T01:16:29.000Z",
        //         "updated": "2024-11-07T01:16:52.000Z"
        //       },
        //       {
        //         "pathway": {
        //           "srcEid": 10156,
        //           "dstEid": 10160,
        //           "sender": {
        //             "address": "0xac80eaa19bf652f13c03940da6fc6c6b45a029f5",
        //             "chain": "meter-testnet"
        //           },
        //           "receiver": {
        //             "address": "0x8f9ec10f71afc10b123234e470d625713fc59514",
        //             "id": "sumer-money",
        //             "name": "Sumer.Money",
        //             "chain": "base-goerli"
        //           },
        //           "id": "10156-10160-0xac80eaa19bf652f13c03940da6fc6c6b45a029f5-0x8f9ec10f71afc10b123234e470d625713fc59514",
        //           "nonce": 9
        //         },
        //         "source": {
        //           "status": "SUCCEEDED",
        //           "tx": {
        //             "txHash": "0xaa91f1737b7d496f8d5ad811382edfa6b8b53b94fec465b632d57517c9db06c9",
        //             "blockHash": "0x0312d2dde63ff77f151ad5fbf9c99403c68d462e9e331abf75955f2def5f1251",
        //             "blockNumber": "51565277",
        //             "blockTimestamp": 1705329809,
        //             "from": "0x57e7e16a2326dc41d02402103a73b4464a8b3eeb",
        //             "blockConfirmations": 1,
        //             "payload": "0x00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000d893c092f7ae9d97c13307f2d66cfb59430b4cb00000000000000000000000000000000000000000000000000000000000000800000000000000000000000000000000000000000000000000de0b6b3a7640000000000000000000000000000000000000000000000000000000000000000001457e7e16a2326dc41d02402103a73b4464a8b3eeb000000000000000000000000",
        //             "value": "9590845676740376",
        //             "adapterParams": {
        //               "version": "1",
        //               "dstGasLimit": "200000"
        //             }
        //           }
        //         },
        //         "destination": {
        //           "status": "SUCCEEDED",
        //           "tx": {
        //             "txHash": "0x52dafd726e8704912f5989aec11a6b6dbff92a938050934c8bfe1a6e517f5f16",
        //             "blockHash": "0x789eef1328f18ce6edcc99320d45e61e60038ec28c3556d58001bf648e0cf5a3",
        //             "blockNumber": 15068108,
        //             "blockTimestamp": 1705329832
        //           }
        //         },
        //         "guid": "0x93d8211dff95c2fe3bb2d2bfabc32a07d7fbe26f9bd826673cf04df2625cb765",
        //         "config": {
        //           "error": false,
        //           "receiveLibrary": "0x145C041566B21Bec558B2A37F1a5Ff261aB55998",
        //           "inboundConfig": {
        //             "blockConfirmation": 1,
        //             "relayerAddress": "0xd682ECF100f6F4284138AA925348633B0611Ae21",
        //             "oracleAddress": "0x53fd4C4fBBd53F6bC58CaE6704b92dB1f360A648",
        //             "proofType": "2",
        //             "utilsVersion": 1,
        //             "proofVersion": "2",
        //             "proofLibraryAddress": "0x3aCAAf60502791D199a5a5F0B173D78229eBFe32",
        //             "ulnVersion": "V2"
        //           },
        //           "outboundConfig": {
        //             "blockConfirmation": 1,
        //             "relayerAddress": "0xf35848b061f7b0A4F69BCA8804947e1EE29Ff734",
        //             "oracleAddress": "0x0E8738298a8E437035e3AeBd57F8DDdC1A1bc44a",
        //             "proofType": "2"
        //           },
        //           "ulnSendVersion": "V2"
        //         },
        //         "status": {
        //           "name": "DELIVERED",
        //           "message": "Destination transaction confirmed"
        //         },
        //         "created": "2024-01-15T14:43:44.000Z",
        //         "updated": "2024-01-15T14:44:04.000Z"
        //       },
        //       {
        //         "pathway": {
        //           "srcEid": 10156,
        //           "dstEid": 10160,
        //           "sender": {
        //             "address": "0xac80eaa19bf652f13c03940da6fc6c6b45a029f5",
        //             "chain": "meter-testnet"
        //           },
        //           "receiver": {
        //             "address": "0x8f9ec10f71afc10b123234e470d625713fc59514",
        //             "id": "sumer-money",
        //             "name": "Sumer.Money",
        //             "chain": "base-goerli"
        //           },
        //           "id": "10156-10160-0xac80eaa19bf652f13c03940da6fc6c6b45a029f5-0x8f9ec10f71afc10b123234e470d625713fc59514",
        //           "nonce": 8
        //         },
        //         "source": {
        //           "status": "SUCCEEDED",
        //           "tx": {
        //             "txHash": "0xa00a13d3a6472eb29b24945a4ff473e05e6665761d5df6823cf76e9154eba95f",
        //             "blockHash": "0x031016b370e11571408e1ef6da1fe1783a12007f53d4ff522cae4f30ad87197d",
        //             "blockNumber": "51386035",
        //             "blockTimestamp": 1705060675,
        //             "from": "0x57e7e16a2326dc41d02402103a73b4464a8b3eeb",
        //             "blockConfirmations": 1,
        //             "payload": "0x00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000d893c092f7ae9d97c13307f2d66cfb59430b4cb00000000000000000000000000000000000000000000000000000000000000800000000000000000000000000000000000000000000000000de0b6b3a7640000000000000000000000000000000000000000000000000000000000000000001457e7e16a2326dc41d02402103a73b4464a8b3eeb000000000000000000000000",
        //             "value": "144906989944994204",
        //             "adapterParams": {
        //               "version": "1",
        //               "dstGasLimit": "200000"
        //             }
        //           }
        //         },
        //         "destination": {
        //           "status": "SUCCEEDED",
        //           "tx": {
        //             "txHash": "0x9be3a4f55844fb12d734337aa5ccda393d9ac8e94ed96ed5e75e6897dbc5d588",
        //             "blockHash": "0xffcfac99f7d8d390124bdbcbccbebaac0e63259e14f0fd829418506c869436b3",
        //             "blockNumber": 14933540,
        //             "blockTimestamp": 1705060696
        //           }
        //         },
        //         "guid": "0xafcc83933cca14949216c56d69eb0af91f0b9390964176060b2e05b243432802",
        //         "config": {
        //           "error": false,
        //           "receiveLibrary": "0x145C041566B21Bec558B2A37F1a5Ff261aB55998",
        //           "inboundConfig": {
        //             "blockConfirmation": 1,
        //             "relayerAddress": "0xd682ECF100f6F4284138AA925348633B0611Ae21",
        //             "oracleAddress": "0x53fd4C4fBBd53F6bC58CaE6704b92dB1f360A648",
        //             "proofType": "2",
        //             "utilsVersion": 1,
        //             "proofVersion": "2",
        //             "proofLibraryAddress": "0x3aCAAf60502791D199a5a5F0B173D78229eBFe32",
        //             "ulnVersion": "V2"
        //           },
        //           "outboundConfig": {
        //             "blockConfirmation": 1,
        //             "relayerAddress": "0xf35848b061f7b0A4F69BCA8804947e1EE29Ff734",
        //             "oracleAddress": "0x0E8738298a8E437035e3AeBd57F8DDdC1A1bc44a",
        //             "proofType": "2"
        //           },
        //           "ulnSendVersion": "V2"
        //         },
        //         "status": {
        //           "name": "DELIVERED",
        //           "message": "Destination transaction confirmed"
        //         },
        //         "created": "2024-01-12T11:58:13.000Z",
        //         "updated": "2024-01-12T11:58:35.000Z"
        //       },
        //       {
        //         "pathway": {
        //           "srcEid": 10156,
        //           "dstEid": 10160,
        //           "sender": {
        //             "address": "0xac80eaa19bf652f13c03940da6fc6c6b45a029f5",
        //             "chain": "meter-testnet"
        //           },
        //           "receiver": {
        //             "address": "0x8f9ec10f71afc10b123234e470d625713fc59514",
        //             "id": "sumer-money",
        //             "name": "Sumer.Money",
        //             "chain": "base-goerli"
        //           },
        //           "id": "10156-10160-0xac80eaa19bf652f13c03940da6fc6c6b45a029f5-0x8f9ec10f71afc10b123234e470d625713fc59514",
        //           "nonce": 4
        //         },
        //         "source": {
        //           "status": "SUCCEEDED",
        //           "tx": {
        //             "txHash": "0xbf64374461ae4d6ad09905013306e39b15324dc55e1a50a4a938a078b6121235",
        //             "blockHash": "0x02c68ba0d538f9b8c15c20b4c12efe83043a80f23ed3181786abf39eb7c281e4",
        //             "blockNumber": "46566304",
        //             "blockTimestamp": 1697848459,
        //             "from": "0x57e7e16a2326dc41d02402103a73b4464a8b3eeb",
        //             "blockConfirmations": 1,
        //             "payload": "0x00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000d893c092f7ae9d97c13307f2d66cfb59430b4cb00000000000000000000000000000000000000000000000000000000000000800000000000000000000000000000000000000000000000001bc16d674ec80000000000000000000000000000000000000000000000000000000000000000001457e7e16a2326dc41d02402103a73b4464a8b3eeb000000000000000000000000",
        //             "value": "102914639403890898",
        //             "adapterParams": {
        //               "version": "1",
        //               "dstGasLimit": "200000"
        //             }
        //           }
        //         },
        //         "destination": {
        //           "status": "SUCCEEDED",
        //           "tx": {
        //             "txHash": "0x4bffa830ec907085f40a8a25a7c832eac1d1ec0193fa0ee238de1e89240879cb",
        //             "blockHash": "0x030100012380b4297e91a440f65d9b06a9d2ba54eeb730b612d9a81e35975a70",
        //             "blockNumber": 11327438,
        //             "blockTimestamp": 1697848492
        //           }
        //         },
        //         "guid": "0xa32e61b9fb9ba2dec473529a46a4f86a2e2fe0d2a5d8c2c73fe11dfec906eb71",
        //         "config": {
        //           "error": false,
        //           "receiveLibrary": "0x145C041566B21Bec558B2A37F1a5Ff261aB55998",
        //           "inboundConfig": {
        //             "blockConfirmation": 1,
        //             "relayerAddress": "0xd682ECF100f6F4284138AA925348633B0611Ae21",
        //             "oracleAddress": "0x53fd4C4fBBd53F6bC58CaE6704b92dB1f360A648",
        //             "proofType": "2",
        //             "utilsVersion": 1,
        //             "proofVersion": "2",
        //             "proofLibraryAddress": "0x3aCAAf60502791D199a5a5F0B173D78229eBFe32",
        //             "ulnVersion": "V2"
        //           },
        //           "outboundConfig": {
        //             "blockConfirmation": 1,
        //             "relayerAddress": "0xf35848b061f7b0A4F69BCA8804947e1EE29Ff734",
        //             "oracleAddress": "0x0E8738298a8E437035e3AeBd57F8DDdC1A1bc44a",
        //             "proofType": "2"
        //           },
        //           "ulnSendVersion": "V2"
        //         },
        //         "status": {
        //           "name": "DELIVERED",
        //           "message": "Destination transaction confirmed"
        //         },
        //         "created": "2023-10-21T00:34:30.000Z",
        //         "updated": "2023-10-21T00:35:12.000Z"
        //       },
        //       {
        //         "pathway": {
        //           "srcEid": 10156,
        //           "dstEid": 10160,
        //           "sender": {
        //             "address": "0xac80eaa19bf652f13c03940da6fc6c6b45a029f5",
        //             "chain": "meter-testnet"
        //           },
        //           "receiver": {
        //             "address": "0x8f9ec10f71afc10b123234e470d625713fc59514",
        //             "id": "sumer-money",
        //             "name": "Sumer.Money",
        //             "chain": "base-goerli"
        //           },
        //           "id": "10156-10160-0xac80eaa19bf652f13c03940da6fc6c6b45a029f5-0x8f9ec10f71afc10b123234e470d625713fc59514",
        //           "nonce": 3
        //         },
        //         "source": {
        //           "status": "SUCCEEDED",
        //           "tx": {
        //             "txHash": "0xd1c6ac1cf1b76f62bcc4fd23f724370d72f04cab25f64b81435d9744cbb508b3",
        //             "blockHash": "0x02c68b768b67a7579cee48f67e30d688c1953ac6c8433e46b80feaa316da8afe",
        //             "blockNumber": "46566262",
        //             "blockTimestamp": 1697848390,
        //             "from": "0x57e7e16a2326dc41d02402103a73b4464a8b3eeb",
        //             "blockConfirmations": 1,
        //             "payload": "0x00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000d893c092f7ae9d97c13307f2d66cfb59430b4cb00000000000000000000000000000000000000000000000000000000000000800000000000000000000000000000000000000000000000001bc16d674ec80000000000000000000000000000000000000000000000000000000000000000001457e7e16a2326dc41d02402103a73b4464a8b3eeb000000000000000000000000",
        //             "value": "102914639403890898",
        //             "adapterParams": {
        //               "version": "1",
        //               "dstGasLimit": "200000"
        //             }
        //           }
        //         },
        //         "destination": {
        //           "status": "SUCCEEDED",
        //           "tx": {
        //             "txHash": "0xcbccb1a0c2d5d1052b94213f93301c02e1c84b040f42229315de8873542b3a43",
        //             "blockHash": "0x8d9dbe3d8fce744290fe586bc4bee31a35ac5a6a21d1e6c6c0267e6f45228fa9",
        //             "blockNumber": 11327401,
        //             "blockTimestamp": 1697848418
        //           }
        //         },
        //         "guid": "0xf9c39c3120151fa51a16869b301016a6d0021f86d783ff66b42b73183853239b",
        //         "config": {
        //           "error": false,
        //           "receiveLibrary": "0x145C041566B21Bec558B2A37F1a5Ff261aB55998",
        //           "inboundConfig": {
        //             "blockConfirmation": 1,
        //             "relayerAddress": "0xd682ECF100f6F4284138AA925348633B0611Ae21",
        //             "oracleAddress": "0x53fd4C4fBBd53F6bC58CaE6704b92dB1f360A648",
        //             "proofType": "2",
        //             "utilsVersion": 1,
        //             "proofVersion": "2",
        //             "proofLibraryAddress": "0x3aCAAf60502791D199a5a5F0B173D78229eBFe32",
        //             "ulnVersion": "V2"
        //           },
        //           "outboundConfig": {
        //             "blockConfirmation": 1,
        //             "relayerAddress": "0xf35848b061f7b0A4F69BCA8804947e1EE29Ff734",
        //             "oracleAddress": "0x0E8738298a8E437035e3AeBd57F8DDdC1A1bc44a",
        //             "proofType": "2"
        //           },
        //           "ulnSendVersion": "V2"
        //         },
        //         "status": {
        //           "name": "DELIVERED",
        //           "message": "Destination transaction confirmed"
        //         },
        //         "created": "2023-10-21T00:33:27.000Z",
        //         "updated": "2023-10-21T00:33:51.000Z"
        //       }
        //     ],
        //     "nextToken": "eyJwcmltYXJ5S2V5IjoiMTAxNTYtMTAxNjAtMHhhYzgwZWFhMTliZjY1MmYxM2MwMzk0MGRhNmZjNmM2YjQ1YTAyOWY1LTB4OGY5ZWMxMGY3MWFmYzEwYjEyMzIzNGU0NzBkNjI1NzEzZmM1OTUxNCIsInNyY1RpbWVzdGFtcCI6MTY5Nzg0ODM5MCwic29ydEtleSI6MywiZnJvbSI6IjB4NTdlN2UxNmEyMzI2ZGM0MWQwMjQwMjEwM2E3M2I0NDY0YThiM2VlYiJ9"
        //   }
        // }
        if (res.data && res.data.data) {
          const formatData = []
          const data = res.data.data
          for (const d of data) {
            const { srcEid, dstEid } = d.pathway
            const { status, tx } = d.source
            const { name } = d.status
            const { failedTx } = d.destination

            const srcNetwork = supportNetworkList.find(net => net.oftBridge2 && net.oftBridge2.eid === srcEid)
            const dstNetwork = supportNetworkList.find(net => net.oftBridge2 && net.oftBridge2.eid === dstEid)
            if (!srcNetwork || !dstNetwork) continue
            formatData.push({
              pathway: {
                // url: require('@/assets/images/network/' + net.networkId + '.png'),
                srcNetwork: {
                  networkId: srcNetwork.networkId,
                  name: srcNetwork.name,
                  logo: require(`@/assets/images/network/${srcNetwork.networkId}.png`)
                },
                dstNetwork: {
                  networkId: dstNetwork.networkId,
                  name: dstNetwork.name,
                  logo: require(`@/assets/images/network/${dstNetwork.networkId}.png`)
                }
              },
              source: {
                status,
                txHash: tx.txHash
              },
              status: {
                name: name.toLowerCase()
              },
              failedTx: {
                txHash: !!failedTx ? failedTx[0].txHash : ''
              }
            })
          }
          console.log('formatData', formatData)
          commit('setMsg', formatData)

          commit('setMsgLoading')
        }
      } catch (e) {
        console.log('get layerzero message error', e.message)
        commit('setMsg', [])
        commit('setMsgLoading')
      }
    }
  },
  async executeLzReceive({ rootState, commit, dispatch }, data) {
    console.log('data', data)
    try {
      const { chainId, currentNetwork } = rootState.wallet
      const { pathway, failedTx } = data
      if (pathway.dstNetwork.networkId !== chainId) {
        return alert(`Please switch to ${pathway.dstNetwork.name} and go on.`)
      }

      const logData = await dispatch('getTransactionReceiptAndLogs', { txHash: failedTx.txHash, rpcEndpoint: currentNetwork.readRpc })
      if (logData) {
        dispatch('tx/executeLzReceive', logData, { root: true })
      }
    } catch(e) {
      console.log('executeLzReceive error', e)
    }
  },
  async getTransactionReceiptAndLogs({ rootState, commit }, { txHash, rpcEndpoint }) {
    try {
          const provider = new ethers.JsonRpcProvider(rpcEndpoint);
          
          const receipt = await provider.getTransactionReceipt(txHash);
          
          // 创建一个Interface实例来解析日志
          const iface = new ethers.Interface(abi);
  
          // 解析日志
          const events = receipt.logs.map(log => {
              try {
                  return iface.parseLog(log);
              } catch (error) {
                  return null; // 如果日志不匹配任何已知事件，返回null
              }
          }).filter(event => event !== null); // 过滤掉无法解析的日志
  
          // 输出解析后的事件
          console.log(events[0].args.toObject());
          return events[0].args.toObject()
      } catch (error) {
          console.error('Error:', error);
      }
  }
}

export const message = {
  namespaced,
  state,
  getters,
  mutations,
  actions
}